export const TEXT: {[index: string]: any} = {
    de: {
      feedback: 'Ihr Feedback:',
      appName: 'diese Applikation',
      appNameGrammar: 'dieser Applikation',
      headline: {
        start: '',
        thankYou: 'Vielen Dank.',
        sorry: 'Es ist ein Fehler aufgetreten.',
        startWithoutApp: 'Wie zufrieden sind Sie mit dem Benutzererlebnis?'
      },
      subHeadline: {
        start: 'Wie zufrieden sind Sie mit dem Benutzererlebnis?',
        thankYou: 'Jedes Feedback macht uns besser.',
        sorry: 'Entschuldigen Sie. Versuchen Sie es bald wieder.',
        startWithoutApp: ''
      },
      text:
        'Wir arbeiten daran, dass unsere Applikationen genauso gut werden wie unsere Autos! Helfen Sie mit, indem Sie uns Ihr Feedback senden.',
      textareaPlaceholder: 'Ausführliches Feedback hinzufügen',
      textareaHint: 'Bitte tragen Sie keine personenbezogenen Informationen wie bspw. Ihren Namen im Feedbackfeld ein.',
      feedbackErrorTooLong: 'Bitte fassen Sie Ihr Feedback kuerzer (max. 1000 Zeichen).',
      reasons: 'Um unsere Stärken und Schwächen besser zu verstehen, würden wir uns über eine kurze Begründung Ihrer Bewertung freuen:',
      sendButton: 'Absenden',
      errorMessage: 'Bitte geben Sie uns Ihr Feedback zwischen 1 und 5 Sternen.',
      error: {
        title: 'Fehler:',
        '301': 'Keine Config-ID übermittelt.',
        '302': 'Config-ID nicht bekannt oder fehlerhaft.',
        '303': 'Server nicht erreichbar. Bitte versuchen Sie es später erneut.'
      },
      imprint: 'Impressum & Rechtliche Hinweise'
    },
    en: {
      feedback: 'Your Feedback:',
      appName: 'this application',
      appNameGrammar: 'this application',
      headline: {
        start: '',
        thankYou: 'Thank You.',
        sorry: 'An error has occurred.',
        startWithoutApp: 'How satisfied are you with this user experience?'
      },
      subHeadline: {
        start: 'How satisfied are you with this user experience?',
        thankYou: 'Every feedback makes us better.',
        sorry: 'Sorry. Try again soon.',
        startWithoutApp: ''
      },
      text:
        'We work to make our apps as good as our cars! Help us by sending us your feedback.',
      textareaPlaceholder: 'Add detailed feedback',
      textareaHint: 'Please do not enter any personal information such as your name in the feedback field.',
      feedbackErrorTooLong: 'Please keep your feedback shorter (max 1000 characters).',
      reasons: 'To better understand our strengths and weaknesses, we would appreciate a brief explanation of your evaluation:',
      sendButton: 'Send',
      errorMessage: 'Please provide your feedback between 1 and 5 stars.',
      error: {
        title: 'Error:',
        '301': 'No Config ID transmitted.',
        '302': 'Config ID not known or incorrect.',
        '303': 'Server unavailable. Please try again later.'
      },
      imprint: 'Imprint & Legal Notice'
    }
  }
  
